module.exports = __webpack_public_path__ + "img/banner3_4_jp.efe4000a.png";